import Avatar from "@material-ui/core/Avatar";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#0A0A0A",
    borderRight: "none",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    zIndex: 1000,
    overflowY: "auto",
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: 0,
      bottom: 0,
      width: "2px",
      background: "linear-gradient(180deg, transparent 0%, #00FF41 20%, #00FF41 80%, transparent 100%)",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      right: 0,
      top: 0,
      bottom: 0,
      width: "1px",
      background: "linear-gradient(180deg, transparent 0%, #1E1E1E 20%, #1E1E1E 80%, transparent 100%)",
    },
  },
  navContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "40px 20px",
    height: "100%",
    width: "100%",
    boxSizing: "border-box",
    justifyContent: "center",
  },
  avatarWrapper: {
    position: "relative",
    marginBottom: "32px",
    "&::before": {
      content: '""',
      position: "absolute",
      top: "-4px",
      left: "-4px",
      right: "-4px",
      bottom: "-4px",
      borderRadius: "50%",
      background: "linear-gradient(135deg, #00FF41 0%, #00CC33 50%, #00FF41 100%)",
      zIndex: 0,
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: "-8px",
      left: "-8px",
      right: "-8px",
      bottom: "-8px",
      borderRadius: "50%",
      background: "transparent",
      boxShadow: "0 0 30px rgba(0, 255, 65, 0.3)",
      zIndex: -1,
    },
  },
  avatar: {
    width: 100,
    height: 100,
    border: "3px solid #0A0A0A",
    position: "relative",
    zIndex: 1,
  },
  nameText: {
    color: "#FFFFFF",
    fontWeight: 600,
    fontSize: "1.1rem",
    marginBottom: "4px",
    textAlign: "center",
  },
  titleText: {
    color: "#00FF41",
    fontWeight: 500,
    fontSize: "0.8rem",
    letterSpacing: "0.15em",
    textTransform: "uppercase",
    marginBottom: "40px",
    textAlign: "center",
  },
  navList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    width: "100%",
  },
  navLink: {
    textDecoration: "none",
    display: "block",
  },
  navItem: {
    color: "#707070",
    padding: "12px 24px",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      top: "50%",
      transform: "translateY(-50%)",
      width: "0px",
      height: "60%",
      background: "#00FF41",
      borderRadius: "0 4px 4px 0",
      transition: "all 0.3s ease",
    },
    "&:hover": {
      color: "#FFFFFF",
      backgroundColor: "rgba(0, 255, 65, 0.05)",
      paddingLeft: "32px",
      "&::before": {
        width: "3px",
      },
    },
  },
  navNumber: {
    color: "#00FF41",
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: "0.75rem",
    fontWeight: 500,
  },
  navText: {
    fontSize: "0.95rem",
    fontWeight: 500,
    letterSpacing: "0.02em",
  },
  divider: {
    width: "60%",
    height: "1px",
    background: "linear-gradient(90deg, transparent 0%, #2A2A2A 50%, transparent 100%)",
    margin: "32px 0",
  },
  statusContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginTop: "32px",
    paddingTop: "20px",
  },
  statusDot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    backgroundColor: "#00FF41",
    boxShadow: "0 0 10px #00FF41",
    animation: "$pulse 2s ease-in-out infinite",
  },
  statusText: {
    color: "#707070",
    fontSize: "0.75rem",
    letterSpacing: "0.05em",
  },
  "@keyframes pulse": {
    "0%, 100%": {
      opacity: 1,
      boxShadow: "0 0 10px #00FF41",
    },
    "50%": {
      opacity: 0.5,
      boxShadow: "0 0 20px #00FF41",
    },
  },
}));

const navItems = [
  { number: "01", label: "Home", href: "#Home" },
  { number: "02", label: "Skills", href: "#Skills" },
  { number: "03", label: "Experience", href: "#Experience" },
  { number: "04", label: "Education", href: "#Education" },
];

export default function NavigationBar() {
  const classes = useStyles();

  return (
    <Hidden smDown>
      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor="left"
      >
        <div className={classes.navContainer}>
          <div className={classes.avatarWrapper}>
            <Avatar
              alt="Berkley Olmstead"
              src="/images/avatar.jpg"
              className={classes.avatar}
            />
          </div>

          <Typography className={classes.nameText}>
            Berkley Olmstead
          </Typography>
          <Typography className={classes.titleText}>
            Full-Stack Developer
          </Typography>

          <nav className={classes.navList}>
            {navItems.map((item) => (
              <a key={item.label} href={item.href} className={classes.navLink}>
                <div className={classes.navItem}>
                  <span className={classes.navNumber}>{item.number}</span>
                  <span className={classes.navText}>{item.label}</span>
                </div>
              </a>
            ))}
          </nav>

          <div className={classes.divider} />

          <div className={classes.statusContainer}>
            <div className={classes.statusDot} />
            <span className={classes.statusText}>Available for work</span>
          </div>
        </div>
      </Drawer>
    </Hidden>
  );
}
